import http from '@services/http'
import { IButtonLog, IReferrerLog } from '@protocol/log'

export default {
  writeButtonLog(data: IButtonLog.Params): Promise<IButtonLog.Schema> {
    return http.post('log/writeButtonLog', data || {})
  },

  doReferrerLog(data: IReferrerLog.Params): Promise<IReferrerLog.Schema> {
    return http.post('log/doReferrerLog', data || {})
  },
}
